import * as React from "react";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import ByzMuiTypography from "../../inputs/ByzMuiTypography"; 

interface TreeViewComponentProps {
  data: { id: number; name: string; children?: any[] }[];
  onSelect?: (id: number) => void; 
}

const TreeViewComponent: React.FC<TreeViewComponentProps> = ({ data, onSelect }) => {
  const renderTreeItems = (
    data: { id: number; name: string; children?: any[] }[]
  ) => {
    return data.map((item) => (
      <TreeItem
        key={item.id}
        itemId={String(item.id)}
        label={<ByzMuiTypography>{item.name}</ByzMuiTypography>}
        onClick={() => {
          if (onSelect) {
            onSelect(item.id); 
          }
        }}
      >
        {item.children && item.children.length > 0
          ? renderTreeItems(item.children)
          : null}
      </TreeItem>
    ));
  };

  return <SimpleTreeView>{renderTreeItems(data)}</SimpleTreeView>;
};

export default TreeViewComponent;